module.exports = "https://static.wmbcdn.com/uniweb/images/45b52b102a860bd3340b0777cd4b7759.svg";